// @ts-nocheck
/* eslint-disable */
/* tslint:disable */
/* prettier-ignore-start */
/** @jsxRuntime classic */
/** @jsx createPlasmicElementProxy */
/** @jsxFrag React.Fragment */
// This class is auto-generated by Plasmic; please do not edit!
// Plasmic Project: gZEhwnQAfx2q6zBpBNhhDQ
// Component: pVyxXczk01pM
import * as React from "react";
import {
  classNames,
  createPlasmicElementProxy,
  deriveRenderOpts,
  renderPlasmicSlot
} from "@plasmicapp/react-web";
import { useDataEnv } from "@plasmicapp/react-web/lib/host";
import AcceptedStatusCard from "../../AcceptedStatusCard"; // plasmic-import: 6mBCCIx-iLnR/component
import "@plasmicapp/react-web/lib/plasmic.css";
import plasmic_antd_5_hostless_css from "../antd_5_hostless/plasmic_antd_5_hostless.module.css"; // plasmic-import: ohDidvG9XsCeFumugENU3J/projectcss
import projectcss from "./plasmic_collect_wise_draft.module.css"; // plasmic-import: gZEhwnQAfx2q6zBpBNhhDQ/projectcss
import sty from "./PlasmicInviteUserCard.module.css"; // plasmic-import: pVyxXczk01pM/css

createPlasmicElementProxy;

export const PlasmicInviteUserCard__VariantProps = new Array();

export const PlasmicInviteUserCard__ArgProps = new Array("userName");

const $$ = {};

function PlasmicInviteUserCard__RenderFunc(props) {
  const { variants, overrides, forNode } = props;
  const args = React.useMemo(
    () =>
      Object.assign(
        {},
        Object.fromEntries(
          Object.entries(props.args).filter(([_, v]) => v !== undefined)
        )
      ),
    [props.args]
  );
  const $props = {
    ...args,
    ...variants
  };
  const $ctx = useDataEnv?.() || {};
  const refsRef = React.useRef({});
  const $refs = refsRef.current;
  return (
    <div
      data-plasmic-name={"root"}
      data-plasmic-override={overrides.root}
      data-plasmic-root={true}
      data-plasmic-for-node={forNode}
      className={classNames(
        projectcss.all,
        projectcss.root_reset,
        projectcss.plasmic_default_styles,
        projectcss.plasmic_mixins,
        projectcss.plasmic_tokens,
        plasmic_antd_5_hostless_css.plasmic_tokens,
        sty.root
      )}
    >
      <div
        data-plasmic-name={"freeBox"}
        data-plasmic-override={overrides.freeBox}
        className={classNames(projectcss.all, sty.freeBox)}
      >
        <div
          data-plasmic-name={"statusCard"}
          data-plasmic-override={overrides.statusCard}
          className={classNames(projectcss.all, sty.statusCard)}
        >
          <AcceptedStatusCard
            data-plasmic-name={"acceptedStatusCard"}
            data-plasmic-override={overrides.acceptedStatusCard}
            className={classNames("__wab_instance", sty.acceptedStatusCard)}
          />
        </div>
        <div
          data-plasmic-name={"userName"}
          data-plasmic-override={overrides.userName}
          className={classNames(projectcss.all, sty.userName)}
        >
          {renderPlasmicSlot({
            defaultContents: "Nike",
            value: args.userName,
            className: classNames(sty.slotTargetUserName)
          })}
        </div>
      </div>
    </div>
  );
}

const PlasmicDescendants = {
  root: ["root", "freeBox", "statusCard", "acceptedStatusCard", "userName"],
  freeBox: ["freeBox", "statusCard", "acceptedStatusCard", "userName"],
  statusCard: ["statusCard", "acceptedStatusCard"],
  acceptedStatusCard: ["acceptedStatusCard"],
  userName: ["userName"]
};

function makeNodeComponent(nodeName) {
  const func = function (props) {
    const { variants, args, overrides } = React.useMemo(
      () =>
        deriveRenderOpts(props, {
          name: nodeName,
          descendantNames: PlasmicDescendants[nodeName],
          internalArgPropNames: PlasmicInviteUserCard__ArgProps,
          internalVariantPropNames: PlasmicInviteUserCard__VariantProps
        }),
      [props, nodeName]
    );
    return PlasmicInviteUserCard__RenderFunc({
      variants,
      args,
      overrides,
      forNode: nodeName
    });
  };
  if (nodeName === "root") {
    func.displayName = "PlasmicInviteUserCard";
  } else {
    func.displayName = `PlasmicInviteUserCard.${nodeName}`;
  }
  return func;
}

export const PlasmicInviteUserCard = Object.assign(
  // Top-level PlasmicInviteUserCard renders the root element
  makeNodeComponent("root"),
  {
    // Helper components rendering sub-elements
    freeBox: makeNodeComponent("freeBox"),
    statusCard: makeNodeComponent("statusCard"),
    acceptedStatusCard: makeNodeComponent("acceptedStatusCard"),
    userName: makeNodeComponent("userName"),
    // Metadata about props expected for PlasmicInviteUserCard
    internalVariantProps: PlasmicInviteUserCard__VariantProps,
    internalArgProps: PlasmicInviteUserCard__ArgProps
  }
);

export default PlasmicInviteUserCard;
/* prettier-ignore-end */
